module.exports = __webpack_public_path__ + "img/lg_ring_y_s_1_null.7e814929.png";